(function(angular){
    'use strict';

    var inject = ['$interval', '$scope', '$window', '$location', '$timeout','bmPermission'];
    var recycleMasterCtl = function($interval:any, $scope:any, $window:any, $location:any, $timeout:any, $bmPermission:any) {

        var vm = this;
        $scope.leftWidth = '400px';

        $scope.bentoSplitterHandle;
        $scope.bentoSplitterGroupLeft;
        $scope.bentoSplitterGroupMain;
        $scope.filterButton;
        $scope.isRecycleComponent = true;

        $bmPermission.has('Internal.CurrentDevelopment').then(function(hasPermission: any) {
            $scope.hasCurrentDevelopmentPermission = hasPermission;
        }).catch(function(error: any) {
            $scope.hasCurrentDevelopmentPermission = false;
            console.error(error);
        });
        // Setting table height. I think we'll do this another way
        // in the end.
        $scope.go = function(path:any){
            $location.path('/' + path);
        };

        var w = angular.element($window);

        $scope.getViewerHeight = function() {
            var grid = document.querySelector('#folder-grid');
            var top = 0;
            if(grid !== null && angular.isFunction(grid.getBoundingClientRect)){
                top = grid.getBoundingClientRect().top;
            }
            return w.height() - top - 75;
        };

        $scope.viewerHeight = $scope.getViewerHeight();

        $scope.updateLeftPanelWidth = function() {
            if (!($scope.bentoSplitterHandle && $scope.bentoSplitterGroupLeft && $scope.bentoSplitterGroupMain)) {
                return;
            }
            const smallWidthBreakPoint = 731;
            const mediumWidthBreakPoint = 1164;

            const smallWidth = '185px';
            const mediumWidth = '250px';
            const largeWidth = '400px';
            const defaultWidth = '0px'
            if (window.innerWidth < smallWidthBreakPoint) {
                if ($scope.bentoSplitterHandle.style.left != defaultWidth) {
                    $scope.bentoSplitterHandle.style.left = smallWidth
                    $scope.bentoSplitterGroupMain.style.left=smallWidth
                    $scope.bentoSplitterGroupLeft.style.width=smallWidth
                    $scope.leftWidth = smallWidth;

                }
            } else if (window.innerWidth < mediumWidthBreakPoint) {
                if ($scope.bentoSplitterHandle.style.left != defaultWidth) {
                    $scope.bentoSplitterHandle.style.left = mediumWidth
                    $scope.bentoSplitterGroupMain.style.left = mediumWidth
                    $scope.bentoSplitterGroupLeft.style.width = mediumWidth
                    $scope.leftWidth = mediumWidth;
                }
            } else {
                if ($scope.bentoSplitterHandle.style.left != defaultWidth) {
                    $scope.bentoSplitterHandle.style.left = largeWidth
                    $scope.bentoSplitterGroupMain.style.left = largeWidth
                    $scope.bentoSplitterGroupLeft.style.width = largeWidth
                    $scope.leftWidth = largeWidth;
                }
            }
        }

        $scope.$watch($scope.getViewerHeight, function(newValue:any) {
            $scope.viewerHeight = 'height: ' + newValue + 'px;';
        });

        w.bind('resize', function() {
            $scope.updateLeftPanelWidth();
            $scope.$apply();
        });

        $scope.$on('bmLanguageChangeSuccess', function(){
            vm._setupGrid();
        });

        var operationsOfBatchComplete = 0;
        $scope.$on('dms-operation-complete', function(event:any, operationModel:any) {
            switch (operationModel.type) {
            case 'moveToRecycle':
            case 'permanentlyDelete':
            case 'restore':
                operationsOfBatchComplete++;
                if (operationsOfBatchComplete % 5 === 0) {
                    $scope.$broadcast('refresh-recycle-grid');
                }
                break;
            }
        });

        $scope.$on('dms-operation-batch-complete', function(){
            if (operationsOfBatchComplete % 5 !== 0) {
                $scope.$broadcast('refresh-recycle-grid');
            }
            operationsOfBatchComplete = 0;
        });

        var clearAlerts = function(){
            $scope.alerts = [];
        };

        vm._setupGrid = function(){
            clearAlerts();
            setTimeout(() => {
                if ($scope.isRecycleComponent) {

                    const paginationTopPadding = '20px';
                    var pagination = document.querySelector('.bento-pagination') as HTMLElement;
                    if (pagination) pagination.style.paddingTop = paginationTopPadding;
                    $scope.bentoSplitterHandle=document.querySelector('.bento-splitter-handle') as HTMLElement;
                    $scope.bentoSplitterGroupLeft=document.querySelector('.bento-splitter-group-left') as HTMLElement;
                    $scope.bentoSplitterGroupMain = document.querySelector('.bento-splitter-group-main') as HTMLElement;
                    $scope.filterButton= document.querySelector('.btn.btn-default.btn-icon.btn-toggle.filter-state') as HTMLElement;

                    $scope.bentoSplitterHandle?.addEventListener('click',function(){
                        setTimeout(()=>{
                            $scope.updateLeftPanelWidth();
                        },0);
                    })
                    $scope.filterButton?.addEventListener('click',function(){
                        setTimeout(()=>{
                            $scope.updateLeftPanelWidth();
                        },0);
                    })
                    $scope.updateLeftPanelWidth();
                }

            },3000)
            if (!$scope.selectedGridItems){
                $scope.selectedGridItems = [];
            }
        };

        $scope.$on('$destroy', function() {
            $scope.isRecycleComponent = false;
            if ($scope.bentoSplitterHandle && $scope.clickListener) {
                $scope.bentoSplitterHandle.removeEventListener('click', $scope.clickListener);
            }
        });

        vm._setupGrid();

        //to inform main-controller.js to update page title when Recycle Bin page is loaded
        $timeout(function() {
            $scope.$emit('pageTitleUpdate', {
                itemType: 'RecycleList'
            });
        });
    };

    recycleMasterCtl.$inject = inject;

    angular.module('onvio.documents').controller('recycleMaster', recycleMasterCtl);

})((window as any).angular);
